import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SharedModule} from '../shared/shared.module';
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {HttpClient} from '@angular/common/http';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {UserGroupsComponent} from './user-groups/user-groups.component';
import { UserGroupsModule } from './user-groups/user-groups.module';
import { WorkingTimeSchemaModule } from './working-time-schema/working-time-schema.module';
import { FilterUsersService } from './core/services/filter-users.service';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './i18n/', '.json');
}

@NgModule({
  imports: [
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    CommonModule,
    UserGroupsModule,
    SharedModule,
    WorkingTimeSchemaModule
  ],
  declarations: [],
  exports: [
    UserGroupsComponent
  ],
  providers: [ FilterUsersService ]
})
export class OrganizationModule { }
